<template>
  <div class="documents-proposal">
    <template v-if="Array.isArray(value) && value.length">
      <p
        v-for="(doc, index) in value"
        :key="index"
        class="documents-link"
        @click="clickHandlerDocument(doc)"
      >
        {{ doc.name }}<span v-if="index !== value.length - 1"> </span>
      </p>
    </template>
    <span v-else>-</span>
  </div>
</template>

<script>
import Vue from "vue";

import { openDocument, isSupportedSource } from "@/utils/documentHandler";

export default Vue.extend({
  name: "DocumentsArrayCellSimple",

  props: ["value", "row", "column", "params"],

  computed: {
    isSupportedSource() {
      return isSupportedSource(this.row?.proposalSource);
    },
  },

  methods: {
    async clickHandlerDocument(file) {
      if (!file || !this.isSupportedSource) return;

      try {
        await openDocument(file, this.row?.proposalSource);
      } catch (error) {
        console.error("Failed to open document:", error);

        this.$toast.error("Не удалось открыть документ");
      }
    },
  },
});
</script>

<style scoped lang="less">
.documents-proposal {
  display: block;

  .documents-link {
    text-decoration: underline;
    cursor: pointer;
    margin-right: 7px;

    &:hover {
      text-decoration: none;
    }
  }
}
</style>
